//Reset data
export const RESET = "AFFECTATION_LIST_RESET"

//Loading
export const SET_TOGGLE_LOADING = "AFFECTATION_LIST_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "AFFECTATION_LIST_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "AFFECTATION_LIST_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "AFFECTATION_LIST_SET_MESSAGE"
export const SET_IS_SUCCESS = "AFFECTATION_LIST_SET_IS_SUCCESS"
export const SET_IS_ERROR = "AFFECTATION_LIST_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "AFFECTATION_LIST_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "AFFECTATION_LIST_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "AFFECTATION_LIST_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "AFFECTATION_LIST_SET_ITEMS"
export const SET_CURRENT_ITEM = "AFFECTATION_LIST_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "AFFECTATION_LIST_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "AFFECTATION_LIST_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "AFFECTATION_LIST_SET_HIDE_MODAL"


export const SET_MODAL = "AFFECTATION_LIST_SET_MODAL"
export const SET_MODAL_CONTENT = "AFFECTATION_LIST_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "AFFECTATION_LIST_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "AFFECTATION_LIST_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "AFFECTATION_LIST_SET_MODAL_TYPE"